import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "html-content p-4"
};
const _hoisted_2 = {
  key: 2,
  class: "flex justify-end mt-6"
};
const _hoisted_3 = {
  class: "right-box flex items-center"
};
import { marked } from 'marked';
import { ElMessageBox } from 'element-plus';
import { ref, onMounted, onUnmounted, inject, toRaw, computed } from 'vue';
import useAppStore from '@views/app.store';
import useMainStore, { storeToRefs } from '@views/main/main.store';
import { assessQuickCreate, assessNodeTaskRestart } from '@views/main/api';
import PDFRender from '@components/PDFRender.vue';
import initIncrementalUpdate from '../mixins/incrementalUpdate.mixin';
import ContentBlock from '../components/ContentBlock.vue';
import FoldBox from '../../FoldBox.vue';
import SourceBlock from '../components/SourceBlock.vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'ReportResult',
  props: {
    item: {},
    content: {}
  },
  setup(__props) {
    const props = __props;
    const appStore = useAppStore();
    const mainStore = useMainStore();
    const {
      incrementalMessageList
    } = storeToRefs(mainStore);
    const pdfRenderRef = ref();
    const foldBoxRef = ref();
    const contentRef = ref();
    const info = ref({});
    const loading = ref(false);
    const disabled = ref(true);
    const showTitle = computed(() => {
      if (info.value.executeStatus === 1) {
        return `任务5：正在汇总全网咨询信息生成网站分析报告...`;
      }
      if (info.value.executeStatus === 2) {
        return `任务5：本次任务任务执行失败请点击重新生成`;
      }
      return `任务5：网站分析报告已生成，可在线/下载查看，本次任务消耗${appStore.getRight('GENERATE_REPORT')}点权益点`;
    });
    const {
      handleIncrementalMessage
    } = initIncrementalUpdate(async message => {
      if (message.id === props.item.id) {
        appStore.getAssessResidualEquityNum();
        disabled.value = true;
        foldBoxRef.value?.setIsFold(true);
        info.value.content = message.incrementalData.data;
        setTimeout(() => {
          mainStore.loadNextMsg(props.item);
        }, 1000);
      }
    });
    const handleAnimateEnd = () => {
      disabled.value = false;
      info.value.executeStatus = 3;
      mainStore.loadNextMsg(props.item);
    };
    const downloadPDF = async () => {
      const htmlContent = await marked.parse(info.value.content);
      try {
        loading.value = true;
        await pdfRenderRef.value?.renderPDF(htmlContent, `${mainStore.sessionDetail.sessionName || '网站分析报告'}.pdf`);
      } catch (error) {
        console.log(error);
      } finally {
        loading.value = false;
      }
    };
    const downloadDOCX = async () => {
      try {
        loading.value = true;
        const windowHtmlDocx = window.htmlDocx;
        // 创建Word文档
        const htmlContent = await marked.parse(info.value.content);
        const doc = windowHtmlDocx.asBlob(htmlContent);
        // 创建下载链接
        const url = URL.createObjectURL(doc);
        const link = document.createElement('a');
        link.href = url;
        link.download = `${mainStore.sessionDetail.sessionName || '网站分析报告'}.docx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } catch (error) {
        console.log(error);
      } finally {
        loading.value = false;
      }
    };
    const openSideEdit = inject('openSideEdit');
    const handleEditView = () => {
      openSideEdit({
        type: 'view_report',
        typeQuery: {},
        contentData: toRaw(info.value),
        title: '网站分析报告',
        callBack: () => {
          setTimeout(() => {
            downloadPDF();
          }, 500);
        }
      });
    };
    const quickCreation = async () => {
      try {
        const {
          sessionId
        } = mainStore.msgParams;
        const {
          data
        } = await assessQuickCreate({
          sessionId
        });
        if (data.keywords.length > 10) {
          await ElMessageBox.confirm('最多只能创建10个关键词,\n是否自动使用前10个关键词？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          });
          data.keywords = data.keywords.slice(0, 10);
        }
        sessionStorage.setItem(sessionId, JSON.stringify({
          keywords: data.keywords,
          websiteInfo: data.websiteInfo,
          selectionModel: data.selectionModel
        }));
        window.open(`/form?type=1&id=${mainStore.msgParams.sessionId}`);
      } catch (e) {
        console.log(e);
      }
    };
    const handleRestart = async () => {
      try {
        await assessNodeTaskRestart({
          sessionId: mainStore.msgParams.sessionId,
          taskNode: 207
        });
        info.value.executeStatus = 1;
      } catch (error) {
        console.log(error);
      }
    };
    onUnmounted(() => {
      mainStore.componentFunMap.delete(props.item.id);
    });
    onMounted(() => {
      if (props.item.id) {
        mainStore.componentFunMap.set(props.item.id, handleIncrementalMessage);
      }
      try {
        if (props.content) info.value = props.content;
        if (props.item.incrementalIds) {
          props.item.incrementalIds.forEach(id => {
            handleIncrementalMessage(incrementalMessageList.value[id]);
          });
        }
        if (!props.item.openAnimate) {
          disabled.value = false;
          foldBoxRef.value?.setIsFold(true);
        }
      } catch (error) {
        info.value = {};
        disabled.value = false;
        console.log(error);
      }
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createBlock(FoldBox, {
        ref_key: "foldBoxRef",
        ref: foldBoxRef,
        id: props.item.id,
        status: info.value.executeStatus || 1,
        onRestart: handleRestart
      }, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString(showTitle.value), 1)]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [info.value.links ? (_openBlock(), _createBlock(SourceBlock, {
          key: 0,
          links: info.value.links,
          class: "mb-4"
        }, null, 8, ["links"])) : _createCommentVNode("", true), info.value.content ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          ref_key: "contentRef",
          ref: contentRef,
          class: "pr-1 bg-white pdf-content rounded-lg"
        }, [_createVNode(ContentBlock, {
          content: info.value.content || '',
          isAnimate: __props.item.openAnimate,
          cusSty: !__props.item.openAnimate ? 1 : undefined,
          isMd: true,
          height: "400px",
          animateTime: 20,
          onAnimateEnd: handleAnimateEnd
        }, null, 8, ["content", "isAnimate", "cusSty"])], 512)) : _createCommentVNode("", true), !__props.item.openAnimate ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_button, {
          class: "view-btn",
          disabled: disabled.value,
          onClick: handleEditView
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createTextVNode(" 全屏查看/预览 ", -1)]))]),
          _: 1
        }, 8, ["disabled"]), _createVNode(_component_el_button, {
          type: "primary",
          class: "submit-btn",
          disabled: disabled.value || !info.value.content,
          loading: loading.value,
          onClick: downloadPDF
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode(" 下载PDF ", -1)]))]),
          _: 1
        }, 8, ["disabled", "loading"]), _createVNode(_component_el_button, {
          type: "primary",
          class: "submit-btn",
          disabled: disabled.value || !info.value.content,
          loading: loading.value,
          onClick: downloadDOCX
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode(" 下载docx ", -1)]))]),
          _: 1
        }, 8, ["disabled", "loading"])])])) : _createCommentVNode("", true), _createVNode(PDFRender, {
          ref_key: "pdfRenderRef",
          ref: pdfRenderRef
        }, null, 512)])]),
        _: 1
      }, 8, ["id", "status"]);
    };
  }
});